export const FEE = {
  nickname: 'PRODUCTS.FEE.nickname',
  icon:'fee'
};
